import React, { useMemo, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { DropdownMenuProps } from 'components/dropdownMenu/dropDownMenu';
import DropdownMenuHeaderTablet from 'components/dropdownMenu/components/dropdownMenuHeader/dropdownMenuHeaderTablet';
import DropdownMenuInnerMobile from 'components/dropdownMenu/components/dropdownMenuInner/dropdownMenuInnerMobile';
import { DateTypeStringHelper } from 'helpers/dateTimeStringHelper';
import ForecastMobile from 'components/forecast/forecastMobile';
import { borderRadiusValues } from 'assets/theme';
import { useAnchorParams } from 'hooks/useAnchorParams';

export default function DropdownMenuTablet({
  initialIsOpen,
  data,
}: DropdownMenuProps) {
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const dtHelper = new DateTypeStringHelper(data.traffic_score.dt);

  const forecastSlot = useMemo(
    () => <ForecastMobile items={data.traffic_score_forecast}></ForecastMobile>,
    [data.traffic_score_forecast]
  );
  const { offsetEl } = useAnchorParams();

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '6px',
        width: offsetEl ? offsetEl.width : '100%',
        position: 'absolute',
        top: offsetEl ? `${offsetEl.top + offsetEl.height}px` : '0',
        left: offsetEl ? offsetEl.left : '0',
        borderRadius: offsetEl ? offsetEl.borderRadius : borderRadiusValues.big,
        zIndex: 2147483647,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: 0.96,
        }}
      >
        <DropdownMenuHeaderTablet
          {...data}
          isOpen={isOpen}
          onChangeIsOpen={setIsOpen}
        ></DropdownMenuHeaderTablet>

        <DropdownMenuInnerMobile
          {...data}
          isOpen={isOpen}
          speedStatProps={{
            score: data.traffic_score.score,
            directSpeed: data.traffic_speed.direct_speed,
            reverseSpeed: data.traffic_speed.reverse_speed,
            timeString: dtHelper.dateTime.time,
          }}
          forecastSlot={forecastSlot}
          dateTime={data.traffic_score.dt}
        ></DropdownMenuInnerMobile>
      </Box>
    </Paper>
  );
}
